import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatCategoryPromoterModel } from 'src/app/model/cat-category-promoter.model';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { ComPromoterCategoryModel } from 'src/app/model/com-promoter-category.model';
import { CatCategoryPromoterService } from 'src/app/services/cat-category-promoter.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComPromoterCategoryService } from 'src/app/services/com-promoter-category.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalScPromoterCategoryComponent } from 'src/app/shared/modal-sc-promoter-category/modal-sc-promoter-category.component';

@Component({
  selector: 'app-sc-promoter-category',
  templateUrl: './sc-promoter-category.component.html',
  styleUrls: ['./sc-promoter-category.component.css']
})
export class ScPromoterCategoryComponent implements OnInit {
  // estado pagina
  public page:string='ScCategoryPromoter';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public categories:ComPromoterCategoryModel[]=[];

  // catalogos
  public promoterCategoryCatalog:CatCategoryPromoterModel[]=[];
  public employeeJobCatalog:CatEmployeeJobModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private promoterCategoryService:ComPromoterCategoryService,
    private catCategoryPromoterService:CatCategoryPromoterService,
    private catEmployeeJobService:CatEmployeeJobService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add=()=> {
    let category=this.creator.newComPromoterCategoryModel();
    let modalRef=this.modalService.open(ModalScPromoterCategoryComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.category=category;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(category:ComPromoterCategoryModel)=> {
    let modalRef=this.modalService.open(ModalScPromoterCategoryComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.category={...category};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  promoterCategory=item=> this.promoterCategoryCatalog.find(pro=> pro.promoterCategoryId===item.promoterCategoryId).description;
  employeeJob=item=> this.employeeJobCatalog.find(emp=> emp.employeeJobId===item.employeeJobId).description;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.promoterCategoryService.getAll(),
      this.catCategoryPromoterService.getAll(),
      this.catEmployeeJobService.getAll()
    )
    .pipe(
      tap(([promoCatResp, promoCatCatResp, employeeJobCatResp]:[any, any, any])=> {
        if(promoCatResp && promoCatCatResp && employeeJobCatResp) {
          this.categories=promoCatResp.data;
          this.promoterCategoryCatalog=promoCatCatResp.data;
          console.log(">>  this.promoterCategoryCatalog= ",  this.promoterCategoryCatalog);
          this.employeeJobCatalog=employeeJobCatResp.data;
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos'));
      })
    )
    .subscribe();
  }
}